import { useNavigate } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";
import { Button } from "@/components/ui/button";
import { Lock, ArrowUpRight } from "lucide-react";

const T = {
  en: { locked: "Locked on your plan", cta: "Upgrade" },
  fr: { locked: "Non inclus dans ton plan", cta: "Upgrader" },
};

// Small inline lock banner for features excluded from the current plan.
export const UpgradeLock = ({ feature, requiredPlan = "Pro", compact = false }) => {
  const { lang } = useLang();
  const t = T[lang] || T.en;
  const nav = useNavigate();
  return (
    <div className={`rounded-xl border border-amber-400/40 bg-amber-400/10 flex flex-wrap items-center gap-3 ${compact ? "p-3" : "p-5"}`} data-testid={`upgrade-lock-${feature}`}>
      <Lock className="w-5 h-5 text-amber-400 shrink-0" />
      <div className="flex-1 min-w-[160px]">
        <div className="font-display font-bold uppercase text-sm">{t.locked}</div>
        <div className="text-xs text-slate-300">{requiredPlan}+</div>
      </div>
      <Button size="sm" onClick={() => nav("/pricing")} data-testid={`upgrade-lock-cta-${feature}`} className="bg-amber-400 hover:bg-amber-300 text-black font-bold text-xs uppercase"><ArrowUpRight className="w-3 h-3 mr-1" />{t.cta}</Button>
    </div>
  );
};
